import React from "react"
import styled from "styled-components"

const Element = styled.h3`
  font-size: 1.17rem;
  /* 18px */
  line-height: 1.5rem;
  /* 24px */
  margin-bottom: 0.5rem;
  /* 24px */
  letter-spacing: -1px;
  font-weight: bold;
  color:var(--textTitle);
`

const Heading3 = ({ children, element, color, tint = "default", ...props }) => (
  <Element as={element || "h3"} color={color} tint={tint} {...props}>
    {children}
  </Element>
)

export default Heading3
